// Distinct from the generic `listingTile`/`contentTile` so these events don't
// collide with the Marketing target's `listingTile` matcher. GTM and Data
// Cloud both key off these elementTypes directly; Marketing does not.
export const AI_LISTING_CARD_ELEMENT_TYPE = 'aiListingCard';
export const AI_RELATED_SEARCH_ELEMENT_TYPE = 'aiRelatedSearch';
export const AI_OVERVIEW_SEARCH_ELEMENT_TYPE = 'aiOverviewSearch';

export const AI_SUMMARY_ELEMENT_NAME = 'AI Search Summary';
export const AI_RELATED_SEARCHES_ELEMENT_NAME = 'AI Related Searches';
export const AI_SEARCH_PILL_ELEMENT_TYPE = 'search pill';

export const AI_SEARCH_TYPE = 'AI Search';
// `search_type` value for a search initiated by clicking a related-search pill.
export const AI_RELATED_SEARCH_TYPE = 'Related AI Search';
// `searchSource` URL param value that flags a search as originating from a related-search pill click.
// Shape matches existing sources (`autoSuggestion`, `topSearch`, `inlineSuggestion`).
export const AI_RELATED_SEARCH_SOURCE = 'aiRelatedSearchPill';
